import { render, staticRenderFns } from "./AppPush.vue?vue&type=template&id=3119195e&"
import script from "./AppPush.vue?vue&type=script&lang=js&"
export * from "./AppPush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports